import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Imports of the module

import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";

import { parseDateWithHours } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type FileDelivery = {
  id: number;
  time_serie_file_date_id?: number;
  time_serie_file_date_label?: string; // Plucked id or label from joined table if available

  client_portfolio_id?: number;
  client_portfolio_label?: string; // Plucked id or label from joined table if available

  status: string;
  sent_at?: string;
  api_url?: string;
  created_at: string;
  updated_at: string;
};

// Definition of the columns

export const file_deliveries_columns: ColumnDef<FileDelivery>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "time_serie_file_date_label",
    header: "Time Series File",
    cell: ({ row }) => {
      const id = row.original.time_serie_file_date_id;
      const label = row.getValue("time_serie_file_date_label");
      if (!id) return null;
      return (
        <ExternalLink
          href={toWorkspacePath(`/admin/qtl - etl/time_serie_file_dates/${id}`)}
          className="text-xs"
          underline="hover"
        >
          {label ?? id}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "client_portfolio_label",
    header: "Client Portfolio",
    cell: ({ row }) => {
      const id = row.original.client_portfolio_id;
      const label = row.getValue("client_portfolio_label");
      if (!id) return null;
      return (
        <ExternalLink
          href={toWorkspacePath(
            `/admin/qtl - dynamic data/client_portfolios/${id}`,
          )}
          className="text-xs"
          underline="hover"
        >
          {label ?? id}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => row.getValue("status"),
  },
  {
    accessorKey: "sent_at",
    header: "Sent At",
    cell: ({ row }) => {
      const value = row.getValue("sent_at");
      return value ? parseDateWithHours(value as string) : "";
    },
  },
  {
    accessorKey: "api_url",
    header: "API Link",
    cell: ({ row }) => {
      const url = row.getValue("api_url");
      if (!url) return null;
      return (
        <ExternalLink
          href={url as string}
          className="text-xs"
          underline="hover"
        >
          {url}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDateWithHours(row.getValue("created_at") as string),
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => parseDateWithHours(row.getValue("updated_at") as string),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
